import TSvgProps from 'svgIcons/type/svgPropsType'

const CbtIcon = (props: TSvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}
    >
      <desc>인적성/필기 아이콘</desc>
      <defs>
        <clipPath id="dvb9mc3h0b">
          <use xlinkHref="#bnouetolpa"></use>
        </clipPath>
      </defs>
      <path fill="none" d="M0 0h20v20H0z" data-name="사각형 34606"></path>
      <g data-name="그룹 50901">
        <g data-name="그룹 47253" transform="translate(2.371 2.792)">
          <rect
            width="4"
            height="3"
            fill="#01a0ff"
            data-name="사각형 32100"
            rx="1.5"
            transform="translate(6 10.999)"
          ></rect>
          <path
            fill="#4a7bff"
            d="M4.439 14.003a.5.5 0 0 1-.217-.95l1.238-.594v-1.356h5.63v1.352l1.237.594a.5.5 0 0 1-.217.95z"
            data-name="합치기 298"
          ></path>
          <g fill="#4a7bff" stroke="#4a7bff" data-name="사각형 32099">
            <rect width="16" height="12" stroke="none" rx="2"></rect>
            <rect
              width="15"
              height="11"
              x="0.5"
              y="0.5"
              fill="none"
              rx="1.5"
            ></rect>
          </g>
        </g>
        <g data-name="그룹 47254">
          <g data-name="그룹 16069">
            <g data-name="그룹 16095">
              <g data-name="그룹 15920">
                <path
                  fill="none"
                  d="M7.364 5.987h5.8v5.8h-5.8z"
                  data-name="사각형 12761"
                ></path>
              </g>
              <g data-name="그룹 16016">
                <g data-name="그룹 15988">
                  <path
                    fill="#fff"
                    stroke="#fff"
                    strokeLinejoin="round"
                    d="M7.896 9.905v1.137h1.1l3.047-2.654-1.279-1.2z"
                    data-name="패스 8449"
                  ></path>
                </g>
              </g>
            </g>
          </g>
          <g
            fill="#fff"
            stroke="#fff"
            data-name="사각형 31979"
            transform="rotate(43 -1.675 17.527)"
          >
            <rect
              id="bnouetolpa"
              width="2.563"
              height="0.644"
              stroke="none"
              rx="0.322"
            ></rect>
            <path
              fill="none"
              d="M0 .144h2.563M2.063 0v.644m.5-.144H0m.5.144V0"
              clipPath="url(#dvb9mc3h0b)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default CbtIcon
